import React from "react";

function ChangePasswordIcons({ fill="#707070" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.642"
      height="10.321"
      viewBox="0 0 20.642 10.321"
    >
      <path
        id="Icon_ionic-md-key"
        data-name="Icon ionic-md-key"
        d="M13.358,14.26a5.44,5.44,0,0,0-4.972-3.573,5.05,5.05,0,0,0-5.012,5.16,5.133,5.133,0,0,0,5.111,5.16,5.3,5.3,0,0,0,4.873-3.573h5.1v3.176h3.429V17.436h2.129V14.26Zm-4.843,3.3a1.712,1.712,0,1,1,1.712-1.712A1.715,1.715,0,0,1,8.516,17.56Z"
        transform="translate(-3.375 -10.688)"
        fill={fill}
      />
    </svg>
  );
}

export default ChangePasswordIcons;
